import { memo } from 'react';

const DealCreationDate = ({ creationDate }) => {
  return <div>{creationDate || '--'}</div>;
};

export default memo(DealCreationDate);
